import { useOutletContext } from "react-router-dom";

export type MinhaAreaLayoutContext = {
  inMinhaAreaLayout: boolean;
};

/** true quando a página está dentro de /minha-area (Navbar e banner vêm do layout). */
export function useMinhaAreaLayout(): boolean {
  const ctx = useOutletContext<MinhaAreaLayoutContext | null>();
  return ctx?.inMinhaAreaLayout === true;
}
